<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="postData"
      label-position="right"
      label-width="150px"
      class="form"
    >
      <el-form-item label="风格名称" prop="title">
        <el-input
          v-model="postData.style_name"
          maxlength="32"
          show-word-limit
          clearable
          placeholder="请输入 2 ~ 32 字符的风格名称"
        />
      </el-form-item>

      <el-form-item>
        <el-button v-if="isAdministrator" type="primary" @click="store" :loading="isSaving">立即添加</el-button>
        <el-button v-else type="primary" @click="applyForStore" :loading="isSaving">申请添加</el-button>
        <el-button @click="RouteConfig.courseStyleList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { store } from '@/api/course-style';
import { store as applyStore } from '@/api/course-style-add-apply';

export default {
  name: RouteConfig.courseStyleAdd.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    postData: {
      style_name: '',
    },
    rules: {
      style_name: [{ required: true, message: '请输入风格名称', trigger: 'change' }],
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  methods: {
    store() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const postData = { ...this.postData };
        if (postData.style_name.length < 2) return '请输入 2 ~ 32 字符内的舞蹈名称';

        this.isSaving = true;
        const { isError } = await store(postData);
        this.isSaving = false;
        if (!isError) RouteConfig.courseStyleList.push();
      });
    },
    applyForStore() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const postData = { ...this.postData };
        if (postData.style_name.length < 2) return '请输入 2 ~ 32 字符内的舞蹈名称';

        this.isSaving = true;
        const { isError } = await applyStore(postData);
        this.isSaving = false;
        if (!isError) RouteConfig.courseStyleAddApplyList.push();
      });
    },
  },
};
</script>
